











import CommonBase from "./CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";

@Component
export default class UnauthorizedPage extends CommonBase {

    get startTo() {
        return {name: rd.start.name};
    }
}
